<template>
  <div v-if="currentUser.role.is_authorizer">
    <div
      v-if="approveStatus === 2 || approveStatus === 3"
      class="flex items-center"
    >
      <AppActivityShowFormBtn
        v-if="!activityDialog.isPreviewResult"
        @click="activityDialog.isOfficeResult = true"
        :disabled="activityDialog.isOfficeResult"
        :hidden="currentUser.role.rank !== 2"
        color="blue"
      />
      <AppShowPreviewBtn
        :style="
          currentUser.role.rank !== 2
            ? 'width: 680px; margin-left: 4px;'
            : 'width: 320px; margin-left: 4px;'
        "
        color="blue"
        colorcode="#2993ce"
        @click="showPreviewResult(true)"
        v-if="!activityDialog.isPreviewResult"
        :disabled="activityDialog.isOfficeResult"
      />

      <AppRejectBtn
        v-if="activityDialog.isPreviewResult"
        color="blue"
        @click="
          submitReject(
            currentPoliticalAction.id,
            currentPoliticalAction.report.id,
            3,
            currentUser.role.rank,
          )
        "
        docType="result"
        :disabled="rejectedAttrs.length === 0"
      />

      <!-- 自分の承認待ちの時または、差戻し依頼が来ている会派事務局の時に承認ボタンを表示する -->
      <AppApproveBtn
        v-if="
          activityDialog.isPreviewResult &&
            (approveStatus === 2 || approveStatus === 3)
        "
        color="blue"
        @click="
          approveRequest(
            currentPoliticalAction.id,
            currentPoliticalAction.report.id,
            3,
            currentUser.role.rank,
          )
        "
        docType="result"
      />
      <AppShowOfficeBtn
        color="blue"
        @click="showPreviewResult(false)"
        :hidden="!activityDialog.isOfficeResult"
      />
    </div>
    <!-- 承認済み -->
    <div v-if="approveStatus == 4" class="flex items-center">
      <AppApprovedBtn color="blue" />
    </div>
    <div v-if="approveStatus == 5" class="flex items-center">
      <AppApproveStateBtn
        color="blue"
        :count="currentPoliticalAction.report.option.current"
        :totalApprove="currentPoliticalAction.report.option.total"
      />
    </div>
    <!-- 承認待ち -->
    <div v-if="approveStatus == 6" class="flex items-center">
      <AppWaitingBtn
        color="blue"
        :isAuthorizer="currentUser.role.is_authorizer"
        :count="currentPoliticalAction.report.option.current"
        :totalApprove="currentPoliticalAction.report.option.total"
      />
    </div>
    <!-- 再確認待ち -->
    <div v-if="approveStatus == 7" class="flex items-center">
      <AppRejectDisabledBtn color="blue" :approveStatus="approveStatus" />
    </div>
  </div>

  <div v-else>
    <!-- 承認待ち -->
    <div v-if="approveStatus == 6" class="flex items-center">
      <AppWaitingBtn
        color="blue"
        :isAuthorizer="currentUser.role.is_authorizer"
        :count="currentPoliticalAction.report.option.current"
        :totalApprove="currentPoliticalAction.report.option.total"
      />
      <AppCancelBtn
        color="blue"
        @click="cancelRequest(currentPoliticalAction.report.id, 4)"
      />
    </div>
    <!-- 承認済み -->
    <div v-else-if="approveStatus == 4" class="flex items-center">
      <AppApprovedBtn color="blue" />
      <AppCancelBtn color="blue" disabled />
    </div>
    <div v-else>
      <div v-if="activityDialog.isPreviewResult" class="items-center">
        <AppApplyBtn
          color="blue"
          @click="submitActivity(currentPoliticalAction.id, 'report-apply')"
          form="resultForm"
          type="submit"
        />
        <button
          class="box-border h-10 bg-white border-4 border-blue disabled:opacity-50 disabled:bg-black"
          style="border-radius: 20px; width: 180px;"
          @click="showPreviewResult(false)"
        >
          <div class="flex flex-row items-center justify-center">
            <edit-circle-icn
              width="20"
              height="20"
              class="mr-1"
            ></edit-circle-icn>
            <span class="text-blue text-lg font-bold leading-tight">
              作成に戻る
            </span>
          </div>
        </button>
      </div>
      <div v-else>
        <AppShowPreviewBtn
          color="blue"
          @click="validate"
          v-if="approveStatus == 0 || approveStatus == 1 || approveStatus == 3"
        />
        <AppTempSaveBtn
          v-if="approveStatus == 0 || approveStatus == 1 || approveStatus == 3"
          @click="submitActivity(currentPoliticalAction.id, 'report')"
          color="blue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { usePoliticalActionDialog } from '@/services/politicalActionToda/usePoliticalActionDialog'
import AppApplyBtn from '@/components/ui/AppApplyBtn'
import AppTempSaveBtn from '@/components/ui/AppTempSaveBtn'
import AppRejectBtn from '@/components/ui/AppRejectBtn'
import AppApproveBtn from '@/components/ui/AppApproveBtn'
import AppShowPreviewBtn from '@/components/ui/AppShowPreviewBtn'
import AppCancelBtn from '@/components/ui/AppCancelBtn'
import AppWaitingBtn from '@/components/ui/AppWaitingBtn'
import AppApprovedBtn from '@/components/ui/AppApprovedBtn'
import AppShowOfficeBtn from '@/components/ui/AppShowOfficeBtn'
import AppActivityShowFormBtn from '@/components/ui/AppActivityShowFormBtn'
import AppRejectDisabledBtn from '@/components/ui/AppRejectDisabledBtn'
import AppApproveStateBtn from '@/components/ui/AppApproveStateBtn'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useResultForm } from '@/services/politicalActionToda/useResultForm'
import { useResultReject } from '@/services/politicalActionToda/useResultReject'

import EditCircleIcn from '@/assets/icons/edit-circle.svg?inline'

export default {
  name: 'ActivitiesDialogResultFooter_TODA',

  components: {
    AppApplyBtn,
    EditCircleIcn,
    AppTempSaveBtn,
    AppRejectBtn,
    AppApproveBtn,
    AppShowPreviewBtn,
    AppCancelBtn,
    AppWaitingBtn,
    AppApprovedBtn,
    AppShowOfficeBtn,
    AppActivityShowFormBtn,
    AppRejectDisabledBtn,
    AppApproveStateBtn,
  },

  props: {
    approveStatus: Number,
  },

  setup() {
    const { currentUser } = useCurrentUser()
    const validate = () => {
      const a = document.getElementById('result-validate-toda')
      a.click()
    }

    return {
      currentUser,
      validate,
      ...usePoliticalActionDialog(),
      ...usePoliticalActions(),
      ...useResultForm(),
      ...useResultReject(),
    }
  },
}
</script>
<style lang=""></style>
